/**
 * Lead Flow Logging - Debug the lead lifecycle: open → call → disposition → next lead
 * Filter in DevTools: [LeadFlow] or LeadFlow
 */
const PREFIX = '[LeadFlow]';

const leadSnapshot = (lead) => {
  if (!lead) return null;
  return {
    leadID: lead.leadID ?? lead.id,
    leadName: lead.leadName,
    leadMobileNumber: lead.leadMobileNumber ?? lead.phone,
    _id: lead._id,
  };
};

export const leadFlowLog = {
  /** Lead displayed on screen / set in store */
  leadDisplayed: (source, lead, extra = {}) => {
    console.log(`${PREFIX} LEAD DISPLAYED [${source}]`, {
      lead: leadSnapshot(lead),
      ...extra,
    });
  },

  /** /next API called */
  nextApiCalled: () => {
    console.log(`${PREFIX} /next API CALLED`);
  },

  /** /next API response received */
  nextApiResponse: (lead, rawResponse, error) => {
    if (error) {
      console.log(`${PREFIX} /next API ERROR`, { error: error?.message ?? error });
      return;
    }
    console.log(`${PREFIX} /next API RESPONSE`, {
      lead: leadSnapshot(lead),
      hadData: !!lead,
      rawSample: rawResponse ? { leadID: rawResponse?.leadID, leadName: rawResponse?.leadName } : null,
    });
  },

  /** Disposition modal opened */
  dispositionOpened: (lead) => {
    console.log(`${PREFIX} DISPOSITION OPENED`, { lead: leadSnapshot(lead) });
  },

  /** Disposition save - before/after */
  dispositionSaveStart: (lead) => {
    console.log(`${PREFIX} DISPOSITION SAVE START`, { lead: leadSnapshot(lead) });
  },
  dispositionSaveSuccess: (disposedLead, steps) => {
    console.log(`${PREFIX} DISPOSITION SAVE SUCCESS`, {
      disposedLead: leadSnapshot(disposedLead),
      steps: steps,
    });
  },
  dispositionSaveError: (err) => {
    console.log(`${PREFIX} DISPOSITION SAVE ERROR`, { error: err?.message ?? err });
  },

  /** Store actions */
  storeAction: (action, payload) => {
    console.log(`${PREFIX} STORE [${action}]`, payload);
  },

  /** Effect / hook triggers */
  effect: (name, data) => {
    console.log(`${PREFIX} EFFECT [${name}]`, data);
  },

  /** State snapshot for debugging */
  stateSnapshot: (label, state) => {
    console.log(`${PREFIX} STATE [${label}]`, state);
  },
};
